import { Component } from '@angular/core';
import { AlertService } from '@app/_services';
import { PatientService } from '@app/_services/patient.service';

@Component({
  templateUrl: 'plan.component.html',
  styleUrls: ['plan.component.scss'],
})
export class PlanComponent {

  tiles = [
    {
      text: 'Reduce Time in Bed  ',
      cols: 1,
      rows: 3,
      index: 1,
      img: '/assets/plan1.png',
      disable: false,
    },
    {
      text: 'Only Go to Bed When Sleepy',
      cols: 1,
      rows: 3,
      index: 2,
      img: '/assets/plan2.png',
      disable: true,
    },
    {
      text: 'Get Out of Bed When Not Sleeping',
      cols: 1,
      rows: 3,
      index: 3,
      img: '/assets/plan3.png',
      disable: true,
    },
    {
      text: 'Keep a Regular Sleep Schedule',
      cols: 1,
      rows: 3,
      index: 4,
      img: '/assets/plan4.png',
      disable: true,
    },
  ];

  mobile_observed = [
    {
      text: 'Reduce Time in Bed  ',
      cols: 1,
      rows: 3,
      index: 1,
      img: '/assets/plan1.png',
      disable: false,
    },
  ];
  
  observedmax_mobile = 1;
  observedmin_mobile = 0;
  currentPage_mobile = 5;
  changePage_mobile(page: number) {
    //do nothing validation:
    if (
      this.observedmax_mobile + page > this.tiles.length ||
      this.observedmin_mobile + page < 0
    )
      return;

    this.observedmax_mobile += page;
    this.observedmin_mobile += page;

    this.mobile_observed = [];
    for (let i = this.observedmin_mobile; i < this.observedmax_mobile; i++) {
      this.mobile_observed.push(this.tiles[i]);
    }
  }
  
  selectedActionPlanList: Array<number> = [1]
  maxStep;
  constructor(
    private patientService: PatientService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.patientService.fetchPatientPlanData()
      .subscribe({
        next: (data) => {
          data.results.forEach(item => {
            this.selectedActionPlanList.push(item.step_name)
          });

          if(!this.selectedActionPlanList.includes(this.currentPage)){
            this.currentLesson(this.currentPage);
          }
          this.maxStep = Math.max(...this.selectedActionPlanList);
        },
        error: (error) => {
          this.alertService.error(error);
        },
      });
  }

  currentPage = 1;

  currentLesson(lesson: number) {

    if (this.selectedActionPlanList.includes(lesson)) {
      this.currentPage = lesson
    } else {
      this.patientService.savePatientPlanData({
        "step_name": lesson
      }).subscribe({
        next: (data) => {
          this.selectedActionPlanList.push(lesson)
          this.maxStep = Math.max(...this.selectedActionPlanList);

          this.currentPage = lesson
        },
        error: (error) => {
          this.alertService.error(error);
        },
      });
    }

  }
}